import * as React from 'react';
import * as I18n from 'i18n-js';
import { CreditCard } from './selectable_credit_card_list_container';
import {
  withUserContext,
  IUserContext,
} from '@reverbdotcom/commons/dist/components/user_context_provider';

import {
  ChildProps,
} from 'react-apollo';
import {
  SelectableCreditCardListQuery,
} from '../schemas/rql';
import { connectCheckoutButtonQuery } from './selectable_credit_card_list_query';

export type IProps = ChildProps<IUserContext, SelectableCreditCardListQuery.Query, SelectableCreditCardListQuery.Variables>;

export function CheckoutPaymentSelectionContinueButton(props: IProps) {
  let isDisabled = false;

  if (props.data && props.data.me && props.data.me.creditCards.length > 0) {
    const selectedCard = props.data.me.creditCards.find((cc: CreditCard) => cc.isSelected);
    if (selectedCard) {
      isDisabled = selectedCard.needsReverification;
    }
  }

  return (
    <div>
      <button
        type="submit"
        name="commit"
        disabled={isDisabled}
        className="button button--green width-100 icon-r-arrow-right"
        data-disable-with={I18n.t('discovery.bundledCheckout.continueButton.pleaseWait')}
      >
        {I18n.t('discovery.bundledCheckout.continueButton.continue')}
      </button>
    </div>
  );
}

export default withUserContext<IProps>(
  connectCheckoutButtonQuery(CheckoutPaymentSelectionContinueButton),
);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/checkout_payment_selection_continue_button.tsx